import styled from 'styled-components'

export const Container = styled.div`
  h2 {
    margin-bottom: 1rem;
  }

  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
  }

  thead {
    font-size: 1.25rem;
  }

  th {
    font-weight: 500;
  }

  th,
  tr,
  td {
    padding: 3px 5px;
    border: 1px solid;
  }
`
